import { useRecoilState, atom} from "recoil";
import useSelectedProduct from "../componentHooks/useSelectedProduct";

import appConfig from "../config/app.config";
import { API_STATUS } from "../constants/app.constants";
import useRestApiCall from "../http.interceptor";
import useFetchUserInfo from "./fetch-user-info/useFetchUserInfo";

const { LOADING, SUCCESS, ERROR } = API_STATUS;

const API_KEY_INITIAL_STATE = {
    status: LOADING,
    content: undefined
};

export const apiKeyAtom = atom({
    key: "apiKeyState",
    default: API_KEY_INITIAL_STATE,
});


const apiKeyPayload = (params) => {
    let apiPayload = {
        method: "GET",
        url: "/api/auth/fetch/apiKey",
        params,
        baseURL: appConfig.apiMarketplaceBaseUrl,
    };
    return apiPayload;
}


const useFetchApiKey = () => {

    const [apiKeysList, setApiKeysList] = useRecoilState(apiKeyAtom);
    
    const { apiCall } = useRestApiCall();
    const { status, content } = apiKeysList;
   

    const fetchApiKey = async ({ product}) => {
        const data = {
            product,
        }
        const payload = apiKeyPayload(data);

        try {
            const response = await apiCall(payload);
            if (response?.data) {
                setApiKeysList({ status: SUCCESS, content: response.data });
                return response.data;
            }
            throw new Error(response.data);

        }
        catch (error) {
            setApiKeysList({ status: ERROR, content: error })
        }
    }

    const clearApiKey = () => {
        setApiKeysList(API_KEY_INITIAL_STATE);
    }



    return { status, content, fetchApiKey, clearApiKey };

}

export default useFetchApiKey;